import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
@Component({
  selector: 'contact-component',
  templateUrl: './contact.component.html'
})
export class ContactComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  ngOnInit() {

  }
}
